import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { HeaderModule } from 'src/app/_component/header/header.module';

import { GuestReportViewComponent } from './guest-report-view.component';
import { PipesModule } from 'src/app/_pipes/pipes.module';
import { MobileFilterComponentModule } from 'src/app/app/_component/_structural/mobile-filter/mobile-filter.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderModule,
    PipesModule,
    MobileFilterComponentModule,
    TranslateModule,
  ],
  declarations: [GuestReportViewComponent],
  exports: [GuestReportViewComponent]
})
export class GuestReportViewComponentModule {}
